import { useEffect } from 'react';
import * as analytics from '../utils/analytics';

export const useAnalytics = () => {
  useEffect(() => {
    // Initialize GA on component mount
    analytics.initGA();
  }, []);

  return {
    trackEvent: (name: string, params: Record<string, any> = {}) => {
      analytics.event(name, params);
    },
    trackPageView: analytics.pageview,
  };
}; 